<template>
  <v-row>
    <v-col>
      <v-card class="mt-4" outlined test-id="transaction-files-section">
        <v-card-text>
          <v-row class="px-2" dense justify="space-between">
            <span class="primary--text cts-font-size-2" test-id="transaction-files-title">
              {{ $vuetify.lang.t('$vuetify.files') }}
            </span>
            <span class="cts-font-size-2" test-id="transaction-files-section-count">
              ({{ addCertificateAsResourceFile(documentsList).length }})
            </span>
          </v-row>
          <v-divider class="my-2" />
          <v-row dense>
            <v-col class="px-2">
              <v-row class="my-2" dense test-id="transaction-files-section-paragraph">
                <span>{{ $vuetify.lang.t('$vuetify.transactionFilesParagraph') }}</span>
              </v-row>
              <TransactionFilesList :certificateVisible="transaction_content?.certification !== '0'"
                :files="addCertificateAsResourceFile(documentsList)"
                @certificate="getTransactionCertification(transaction_content?.certification)" />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import const_global from "@/constants/global";
import const_icons from "@/constants/icons";
import TransactionFilesList from "@/components/sections/transactions/components/TransactionFilesList.vue";

  export default {
    name: "TransactionDetailFilesSection",
    components: {
      TransactionFilesList,
    },
    data() {
      return {
      const_icons,
      const_global,
      
      };
    },
    props: {
    transaction_content: Object,
    transactionStatus: Object,
    getTransactionCertification: Function,
    documentsList: Array,
    
    },
    methods: {
      addCertificateAsResourceFile(files) {
      if (this.transaction_content?.certification !== "0" && this.transaction_content?.certification !== "") {
        const newFiles = [...files];
        newFiles.push({
          key: "certificate",
          type: "pdf",
        });
        return newFiles;
      }
      return files;
    },
  }
};
</script>